import { defineStore } from 'pinia'
import Storage from 'vue-ls'
const options = {
  namespace: 'vue_fire_vue_', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
}

export const { ls } = Storage.useStorage(options)

export const useTokenStore = defineStore('tokenStore', {
  actions: {
    getToken() {
      return ls.get('token')
    },
    setToken(token: string) {
      ls.set('token', token)
    },
    removeToken(name = 'token') {
      ls.remove(name)
    },
    clear() {
      ls.clear()
    },
  },
})
